/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {FunctionComponent} from 'react';
import Block from "../../../atoms/layout/Block";
import {TagList} from "../../../molecules/finder/TagList";
import {FilterContainer} from "./FilterContainer";
import {CheckboxSize} from "../../../atoms/forms/Checkbox";
import {IBasicListFilter} from "../../../../interfaces/organisms/finders/filter/IBasicListFilter";

export const BasicListFilter: FunctionComponent<IBasicListFilter> = ({ filter, selected, toggleTag,
                                                                       showSearchItemAsFilter, searchTerm,
                                                                       setSearch }) => {

    if (filter == null || filter.tags == null || filter.tags.length === 0) {
        return null;
    }

    return <Block className={`finder__filter filter-${filter.type.toLowerCase()}`}>
        <FilterContainer filter={{...filter}}
                         selected={selected}
                         toggleTag={toggleTag}
                         defaultOpen={true}
                         showSearchItemAsFilter={showSearchItemAsFilter}
                         searchTerm={searchTerm}
                         setSearch={setSearch}>

            <div className={"finder__filter-body open"}>
                <TagList tags={filter.tags}
                         selected={selected}
                         onTagSelect={toggleTag}
                         size={CheckboxSize.md}/>
            </div>

        </FilterContainer>
    </Block>

}
